export default {
  node: {},
  nodeData: [],
  linkData: [],
  nodeInfo: {}
};
